<template>
  <v-layout row wrap justify-center align-content-start>
    <v-card width="500px">
      <v-toolbar flat dense class="primary" dark>
        <v-toolbar-title>New User</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>  
      <v-flex layout row wrap align-center justify-center pt-4 pl-4 pr-4>
        <!--<v-flex xs12 sm6 pr-2 pl-2>-->
          <!--<v-text-field-->
            <!--v-model="newUser.first_name"-->
            <!--type="text"-->
            <!--name="first_name"-->
            <!--label="*First Name"-->
            <!--box-->
            <!--@input="$v.newUser.first_name.$touch()" -->
            <!--:error-messages="firstErrors"-->
          <!--&gt;</v-text-field>-->
        <!--</v-flex> -->
        <!--<v-flex xs12 sm6 pr-2 pl-2>-->
          <!--<v-text-field-->
            <!--v-model="newUser.last_name"-->
            <!--type="text"-->
            <!--name="last_name"-->
            <!--label="*Last Name"-->
            <!--box-->
            <!--@input="$v.newUser.last_name.$touch()" -->
            <!--:error-messages="lastErrors"-->
          <!--&gt;</v-text-field>-->
        <!--</v-flex> -->
        <v-flex xs12 pr-2 pl-2>
          <v-text-field v-model="newUser.email" type="text" name="email" label="*Email" box
                        @input="$v.newUser.email.$touch()" >

          </v-text-field>
        </v-flex>

        <v-flex xs12 sm6 pr-2 pl-2>
          <!--<v-text-field label="*Vehicle Make" v-model="form.device_version" :rules="[rules.required]" box ></v-text-field>-->
          <v-autocomplete :items="$store.getters.getUserStatuses.sort()" label="*User Status"
                          item-text="name" item-value="id"
                          v-model="newUser.status" :rules="[rules.required]" box >

          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 pr-2 pl-2>
          <!--<v-text-field label="*Vehicle Model" v-model="form.sim_pack" :rules="[rules.required]" box ></v-text-field>-->
          <v-autocomplete :items="$store.getters.getUserRoles.sort()" label="*User Role"
                          item-text="name" item-value="id"
                          v-model="newUser.role" :rules="[rules.required]" box >

          </v-autocomplete>
        </v-flex>

        <v-flex xs12 sm6 pr-2 pl-2>
          <v-text-field
            v-model="newUser.password"
            type="password"
            name="password"
            label="*Password"
            box
            @input="$v.newUser.password.$touch()" 
            :error-messages="passwordErrors">

          </v-text-field>
        </v-flex> 
        <v-flex xs12 sm6 pr-2 pl-2>
          <v-text-field
            v-model="newUser.confirmPassword"
            type="password"
            name="password"
            label="*Confirm Password"
            box
            @input="$v.newUser.confirmPassword.$touch()" 
            :error-messages="confirmErrors"
          ></v-text-field>
        </v-flex>    

      </v-flex>
      <v-card-actions class="pl-4 pr-4 pb-4">
        <v-flex xs12 layout row wrap>
          <v-flex xs12 sm6 pl-2 pr-2 pb-2>
            <v-btn class="error" block dark flat="flat" @click="cancel()">Cancel</v-btn>
          </v-flex>
          <v-flex xs12 sm6 pl-2 pr-2 pb-2>
            <v-btn class="primary" block dark flat="flat" v-on:click="submit()">Add User</v-btn>
          </v-flex>       
        </v-flex>
      </v-card-actions> 
    </v-card>
  </v-layout>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required,email,sameAs } from 'vuelidate/lib/validators'
import UserService from "@/services/UserService";

export default {
  name: "NewUser",
  mixins: [validationMixin],
  components: {},
  data() {
    return {
      loading: false,
      loadingTime: 1000,
      newUser: { 
        email: null, 
        first_name: null, 
        last_name: null, 
        password: null, 
        role: null,
        status: null,
      confirmPassword:null      
      },
      rules: {
        required: value => !!value || "Required."
      },
    };
  },
  validations: {
    newUser: { 
      email: { required, email }, 
      // first_name: { required },
      // last_name: { required },
      password: { required }, 
      confirmPassword:{ required,sameAsPassword:sameAs('password') }  
    },
  },
  computed:{
    emailErrors () {
      const errors = [];
      if (!this.$v.newUser.email.$dirty) return errors;
      !this.$v.newUser.email.required && errors.push('Email is required');
      !this.$v.newUser.email.email && errors.push('Invalid Email');
      return errors
    },
    firstErrors () {
      const errors = [];
      if (!this.$v.newUser.first_name.$dirty) return errors;
      !this.$v.newUser.first_name.required && errors.push('First name is required');
      return errors
    },
    lastErrors () {
      const errors = [];
      if (!this.$v.newUser.last_name.$dirty) return errors;
      !this.$v.newUser.last_name.required && errors.push('Last name is required');
      return errors
    },
    passwordErrors () {
      const errors = [];
      if (!this.$v.newUser.password.$dirty) return errors;
      !this.$v.newUser.password.required && errors.push('Password is required');
      return errors
    },
    confirmErrors () {
      const errors = [];
      if (!this.$v.newUser.confirmPassword.$dirty) return errors;
      !this.$v.newUser.confirmPassword.required && errors.push('Confirm password is required');
      !this.$v.newUser.confirmPassword.sameAsPassword && errors.push('Passwords do not match');
      return errors
    },
  },
  mounted() {
    this.getAll(); //todo add prior things
  },
  methods: {
    async getAll() {
      try {
        const statusResponse = await UserService.getAllUserStatus();
        const rolesResponse = await UserService.getAllUserRoles();
        console.log("statusResponse",statusResponse);
        console.log("rolesResponse",rolesResponse);

        this.$store.dispatch("setUserRoles", rolesResponse.data.data);
        this.$store.dispatch("setUserStatuses", statusResponse.data.data);
      }catch (err) {
        console.log(err);
      }
    },
    cancel: function(){      
      // this.$store.dispatch('editUser', null)
      // this.$router.push({name: 'allUsers'})
      this.$router.go(-1)
    },
    clearForm: function (){
      this.newUser.email= null;
      this.newUser.first_name= null;
      this.newUser.last_name= null;
      this.newUser.password= null;
      this.newUser.role= null
    },
    async submit(){
        try{
          var color = "info";
          this.newUser.role = parseInt(this.newUser.role) || null;
          this.newUser.status = parseInt(this.newUser.status) || null;
          console.log("submit form", this.newUser);
          const response = await UserService.create(this.newUser);
          // console.log(response)
          if(response.data.code > 200){
          color = "warning"
          }else if(response.data.result == 2000){
          color = "success";
          this.clearForm();
          // this.$router.push({name: 'allUsers'})
          this.$router.go(-1)
          }
          this.$store.dispatch('setSnackbar', {show: true, text: response.data.message, color: color, x:'right', timeout: 3000})
        }catch(err){
          console.log(err);
          this.$store.dispatch('setSnackbar', {show: true, text: "Creation error occured", color: "error", x:'right', timeout: 3000})
        }
    }
  }
}
</script>

<style scoped>

</style>
